import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { rutClean, rutFormat } from 'src/app/utils/rut.directive';
import { ClienteService } from '../cliente.service';

@Component({
  selector: 'app-cliente-update',
  templateUrl: './cliente-update.component.html',
  styleUrls: ['./cliente-update.component.scss']
})
export class ClienteUpdateComponent implements OnInit {

  @Input() element: any;
  form: FormGroup = new FormGroup({});

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: ClienteService,
    public formatter: FormatterService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      nombre: ['', [Validators.required]],
      apellido: ['', [Validators.required]],
      rut: ['', []],
      fono: [null],
    });

    this.form.patchValue(this.element);
    if(this.element.rut) {
      this.form.patchValue({rut: rutFormat(this.form.value.rut)});
    }
  }

  changed_rut(element: any) {
    let htmlInputElement: HTMLInputElement = <HTMLInputElement>element.target;
    htmlInputElement.value = rutFormat(htmlInputElement.value) || '';
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      if(this.form.value.rut) {
        let rut = rutClean(this.form.value.rut);
        this.form.controls['rut'].setValue(rut);
      }
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Cambios realizados con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo actualizar la información del cliente.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }
}